import React from 'react';
import { useRecoilState } from 'recoil';
import { StyledSideMenuSwitch } from './SideMenuSwitch.style';

// Recoil States
import { isSideMenuOpenState } from '../../atoms';

const SideMenuSwitch = (props) => {
  const [isSideMenuOpen, setIsSideMenuOpen] = useRecoilState(isSideMenuOpenState);

  const onSideMenuSwitchClicked = (oEvent) => {
    // Update Recoil state
    setIsSideMenuOpen(!isSideMenuOpen);
  };

  return (
    props.visible ?
      <StyledSideMenuSwitch onClick={onSideMenuSwitchClicked}>
        { isSideMenuOpen ? "close" : "segment"}
      </StyledSideMenuSwitch>
    : <></>
  );
};

export default SideMenuSwitch;
